import { Stack, Typography } from '@mui/material';
import { Number3 } from '@fabric-web/3d-viewer';
import { XYZFields } from './XYZFields';
import { ROLL_PITCH_YAW_LABELS } from '../constants';

type Props = {
  position: Number3;
  setPosition: (position: Number3) => void;
  rotation: Number3;
  setRotation: (rotation: Number3) => void;
  isDisabled?: boolean;
};

export const PoseFields = ({ position, setPosition, rotation, setRotation, isDisabled }: Props) => {
  return (
    <>
      <Stack direction="column" key="position-stack">
        <Typography>Position</Typography>
        <XYZFields
          values={position}
          setValues={setPosition}
          precision={3}
          isDisabled={isDisabled}
        />
      </Stack>

      <Stack direction="column" key="rotation-stack">
        <Typography>Rotation</Typography>
        <XYZFields
          values={rotation}
          setValues={setRotation}
          labels={ROLL_PITCH_YAW_LABELS}
          precision={12}
          isDisabled={isDisabled}
        />
      </Stack>
    </>
  );
};
